import type {MapCoordinates} from './map';
import type {Media} from './media';
import type {NewsCardView} from './news';
import type {UnitTypeCardView} from './unit';

export enum PhaseStatus {
  Delivered = 'delivered',
  SoldOut = 'sold-out',
}

export interface PhaseCardView {
  uuid: string;
  title: string;
  image: Media;
  projectLabel: string;
  location: string;
  status: PhaseStatus[] | undefined;
}

export interface PhaseDetailView {
  uuid: string;
  projectUuid: string;
  name: string;
  imageUrl?: string;
  projectLabel: string;
  location: string;
  logoUrl?: string;
  gallery: Media[];
  status: PhaseStatus[] | undefined;
  description?: string;
  brochureUrl?: string;
  tourUrl?: string;
  amenities: {icon: string; label: string}[];
  masterplan?: Media;
  nearbyImage?: Media;
  linkLocation?: string;
  nearbyCoordinates?: MapCoordinates;
  nearby: {icon?: string; label: string; minutes: number; mapsUrl?: string}[];
}

export interface PhaseDetailPageData {
  phase: PhaseDetailView;
  unitTypes: UnitTypeCardView[];
  latestNews: NewsCardView[];
}

/** Maps a phase status to its i18n label key (Delivered / Sold Out badges). */
export function phaseStatusKey(status: PhaseStatus[] | PhaseStatus | undefined): string[] | undefined {
  if (!status) {
    return undefined;
  }
  const statuses = Array.isArray(status) ? status : [status];
  const keys: string[] = [];
  for (const s of statuses) {
    if (s === PhaseStatus.Delivered) {
      keys.push('delivered_phase');
    } else {
      keys.push('sold_out');
    }
  }
  return keys.length > 0 ? keys : undefined;
}
